import PropTypes from 'prop-types';

export default function OutlineAi(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="m6.381 5.193-2.366 7.383a.274.274 0 0 0 .256.363h.663a.274.274 0 0 0 .262-.197l.37-1.183h3.24l-.045-.073.406 1.256a.274.274 0 0 0 .263.197h.662a.274.274 0 0 0 .262-.359L7.989 5.197A.276.276 0 0 0 7.726 5H6.637a.274.274 0 0 0-.256.193Zm-.42 5.183 1.22-3.8 1.231 3.8h-2.45ZM12.541 5h-.63a.276.276 0 0 0-.277.276v7.383c0 .152.124.276.276.276h.631a.276.276 0 0 0 .276-.276V5.276A.276.276 0 0 0 12.541 5ZM18.089 16.13l1.786-.704a.197.197 0 0 0 0-.366l-1.786-.704a2.49 2.49 0 0 1-1.398-1.398l-.704-1.775a.197.197 0 0 0-.367 0l-.704 1.775a2.482 2.482 0 0 1-1.398 1.398l-1.775.704a.197.197 0 0 0 0 .366l1.775.704a2.48 2.48 0 0 1 1.398 1.399l.704 1.774a.197.197 0 0 0 .295.092.197.197 0 0 0 .072-.092l.704-1.774a2.488 2.488 0 0 1 1.398-1.399Z"
                fill={color}
            />
            <path
                d="M10.5 16H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6"
                stroke={color}
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineAi.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
